new Vue({
    el: '#optOut',
    data() {
        return {
            mobile_number: '',
            sent: false,
            sending: false,
            error: false,
            optout: false,

            reason: '',
            reason_other: '',
            suggestion: '',
            suggestion_other: '',
        }
    },

    methods: {
        submit: function (event) {
            event.preventDefault();
            this.error = false;

            let self = this;


            this.sending = true;
            axios.post('https://shop.belomed.com/api/v1/solus/unsubscribe', {
                reason: this.reason == 'Other' ? this.reason_other : this.reason,
                suggestion: this.suggestion == 'Other' ? this.suggestion_other : this.suggestion,
                mobile_number: this.mobile_number
            }).then(function (response) {
                self.sent = true;
                self.sending = false;
            }).catch(function (error) {
                self.error = true;
            });


        },
    }
})